<template>
	<v-btn :class="[textTransform]" outlined depressed class="botao-cancelar text-capitalize" min-width="100" @click="cancelar">
		{{ label }}
	</v-btn>
</template>

<script>
export default {
	name: 'botao-cancelar',
	props: {
		label: {
			type: String,
			default: 'Cancelar',
		},
		textTransform: {
			type: String,
			default: 'cp-text-inherit',
		},
	},
	methods: {
		cancelar() {
			this.$emit('cancelar')
		},
	},
}
</script>

<style lang="stylus" scoped>
.botao-cancelar
	color #999 !important
</style>
